require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-why-and-how-should-mdbs-invest-in-climate-resilien.json") })
        }
      }, "path---en-us-update-why-and-how-should-mdbs-invest-in-climate-resilien");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-why-and-how-should-mdbs-invest-in-climate-resilien!./.cache/json/en-us-update-why-and-how-should-mdbs-invest-in-climate-resilien.json
// module id = 860
// module chunks = 231608221292675